/*
* @Author: abhishek714
* @Date:   2025-03-05 12:39:56
* @Last Modified by:   abhishek714
* @Last Modified time: 2025-03-05 12:52:29
*/
import React from 'react';
import './Loader.css';

const Loader = ({ message = 'Loading...', isLoading }) => {
  if (!isLoading) return null;
  return (
    <div className="bg form-spinner gap-2">
      <div className="form-loader"></div>
      <span className="fw-bold">{message}</span>
    </div>
  );
};

export default Loader;